import React from 'react';
import { Company } from '../types/Company';
import { useAuth } from '../../auth/contexts/AuthContext';

interface CompanyTabsProps {
  selectedCompany: Company | null;
  selectedOption: 'translations' | 'translate' | null;
  onBackToCompanySelection: () => void;
  onOptionSelect: (option: 'translations' | 'translate') => void;
}

const CompanyTabs: React.FC<CompanyTabsProps> = ({
  selectedCompany,
  selectedOption,
  onBackToCompanySelection,
  onOptionSelect
}) => {
  const { canStartNewTranslation } = useAuth();
  
  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Navigasyon ve Header */}
      <div className="mb-6">
        <div className="flex items-center mb-4">
          <button
            onClick={onBackToCompanySelection}
            className="flex items-center text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"/>
            </svg>
            <span className="text-sm font-medium">Şirket Seçimi</span>
          </button>
        </div>
        
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            {selectedCompany?.name}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Yapmak istediğiniz işlemi seçin
          </p>
        </div>
      </div>

      {/* Option Cards */}
      <div className={`grid grid-cols-1 ${canStartNewTranslation() ? 'md:grid-cols-2' : ''} gap-6`}>
        {/* Çeviriler Card */}
        <div
          onClick={() => onOptionSelect('translations')}
          className="bg-white/70 dark:bg-gray-800/70 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-8 cursor-pointer hover:shadow-xl hover:border-blue-400 dark:hover:border-blue-500 transition-all duration-300 group"
        >
          <div className="text-center">
            <div className="w-16 h-16 bg-purple-100 dark:bg-purple-900/30 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-purple-200 dark:group-hover:bg-purple-800/40 transition-colors">
              <svg className="w-8 h-8 text-purple-600 dark:text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
              {selectedCompany?.name} Çevirileri
            </h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Geçmiş çevirilerinizi görüntüleyin ve yönetin
            </p>
            <div className="inline-flex items-center text-purple-600 dark:text-purple-400 font-medium">
              Çevirileri Görüntüle
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Çeviri Yap Card - Sadece admin görebilir */}
        {canStartNewTranslation() && (
          <div
            onClick={() => onOptionSelect('translate')}
            className="bg-white/70 dark:bg-gray-800/70 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-8 cursor-pointer hover:shadow-xl hover:border-blue-400 dark:hover:border-blue-500 transition-all duration-300 group"
          >
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 dark:group-hover:bg-blue-800/40 transition-colors">
                <svg className="w-8 h-8 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                {selectedCompany?.name} İçin Çeviri Yap
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                Yeni dosya yükleyip çeviri işlemi başlatın
              </p>
              <div className="inline-flex items-center text-blue-600 dark:text-blue-400 font-medium">
                Çeviri Başlat
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"/>
                </svg>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyTabs;
